module.exports = __webpack_public_path__ + "static/img/ticketSendMobileTpl.361cc03c.png";